import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';

import styles from './documentListStyles';
import Expandable from 'buyside/components/presentation/Expandable/expandable';
import Link from 'buyside/components/presentation/Link/link';
import Icon from 'buyside/components/presentation/Icon/icon';

import { getFilepathExtension, getExtensionIcon } from 'buyside/util/fileHelper';

const DocumentList = ({ title, documents, urlFn }) => (
  <div>
    {title && <h4 className={styles.documentListTitle}>{title}</h4>}
    <ul className={styles.documentList}>
      <Expandable maxItems={8}>
        {documents.map((doc, idx) => (
          <li key={idx} className={styles.documentListItem}>
            {doc.filename ? (
              <Link className={styles.documentLink} to={urlFn(doc.id)}>
                <Icon
                  type={getExtensionIcon(getFilepathExtension(doc.filename || ''))}
                  style={styles.fileTypeIcon}
                />
                {doc.name || doc.filename}
              </Link>
            ) : (
              <Link className={styles.documentLink} to={doc.url} target="_blank">
                <FontAwesomeIcon icon={faLink} className={styles.fileTypeIcon} />
                {doc.name || doc.filename}
              </Link>
            )}
            {doc.category && <span className={styles.documentInfo}>{doc.category}</span>}
            {doc.description && <span className={styles.documentInfo}>{doc.description}</span>}
          </li>
        ))}
      </Expandable>
    </ul>
  </div>
);

export default DocumentList;
